export default {
  idNumber: 'رقم الهوية/الإقامة',
  dob: 'تاريخ الميلاد',
  terms:
    'بالنقر على "التالي"، فإنك توافق على السماح لتأميني بالتدقيق على معلوماتي أو معلومات طلبي مع أي جهة مخولة بالتدقيق على المعلومات',
  submit: 'اشتر الآن',
  processing: 'جاري معالجة طلبك...',
  schemeTitle: 'إختر طريقة الحصول على الخصم اذا كنت تعمل لدى احدى هذه الجهات.',
  schemeSubTitle: 'اختر جهتك لتطبيق مزاياها:',
  businessEmail: 'بريد العمل الالكترونى',
  nationalIdValidationLabel:
    'يمكنك التحقق من وجود خصومات مرتبطة بالجهة المُختارة عن طريق الضغط على "تحقق" ليتم التحقق عن طريق رقم الهوية / الاقامة',
  nationalId: 'رقم الهوية / الاقامة',
  entityCode: 'اسم الجهة',
  entityPromoCode: 'رمز الجهة',
  apply: 'تطبيق',
  resend: 'إعادة إرسال',
  schemeVerificationFailed: 'تعذر العثور على الجهة',
  schemeVerificationNationalIdFailed: 'لم نستطع التحقق من جهتك',
  emailOTPVerificationFailed:
    'رمز تحقق غير صحيح، الرجاء تفقد بريدك الإلكتروني و المحاولة مرة أخرى',
  otpRequired: 'رمز التحقق مطلوب',
  sendVerification: 'ارسل رمز التحقق',
  verificationCode: 'رمز التحقق',
  verify: 'تحقق',
  resendCode: 'لم تستلم رمز التحقق؟ إعادة إرسال رمز التحقق [{{timeLeft}}]',
  schemeVerificationSuccess:
    'لقد حصلت على الخصم بنجاح، أكمل عملية الشراء لتطبيقه.',
  entityCodeRequired: 'رمز الجهة مطلوب',
  optionRequired: 'الخيار مطلوب',
  emailFormatError: 'يرجى إدخال بريد إلكتروني صالح',
  emailRequired: 'بريد إلكتروني مطلوب',
  promoCodeRequired: 'ادخل رمز الجهة',
  idNumberRequired: 'يرجى ادخال رقم الهوية او الإقامة',
  idNumberInvalid:
    'الرقم المدخل غير صحيح، رجاء التحقق من الرقم والمحاولة مرة أخرى',
  dateOfBirthRequired: 'تاريخ الميلاد مطلوب',
  ageRestriction: 'يجب أن يكون عمرك بين {{min}} و {{max}} سنة',
  identityMismatch:
    'رجاء التأكد من مطابقة الهوية لمالك الوثيقة مع الهوية المٌسجَل الدخول بها',
  anatIdentityMismatch:
    'رجاء الملاحظة بأن الهوية المستخدمة في الدخول للحساب مختلفة عن الهوية المستخدمة عن طريق أناة',
} as const
